'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function BGFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-6aj3wstar", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-x9exix5kc", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-wgdcf6ws1" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-wgdcf6ws1", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-6aj3wstar)" }, /* @__PURE__ */ React.createElement("use", { fill: "#5eaa22", xlinkHref: "#mantine-wgdcf6ws1" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 0h32v8H0z", mask: "url(#mantine-x9exix5kc)" }), /* @__PURE__ */ React.createElement("path", { fill: "#e22c18", d: "M0 16h32v8H0z", mask: "url(#mantine-x9exix5kc)" })))
  );
}

export { BGFlag };
//# sourceMappingURL=BG.mjs.map
